import uniqueId from "lodash/uniqueId";

// https://stackoverflow.com/questions/26501688/a-typescript-guid-class
export class IdHelper {
  public static newGuid() {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);
    array[6] = (array[6] & 0x0f) | 0x40; // Set version to 4
    array[8] = (array[8] & 0x3f) | 0x80; // Set variant to 10
    return [...array].map((b, i) => (i === 4 || i === 6 || i === 8 || i === 10 ? '-' : '') + b.toString(16).padStart(2, '0')).join('');
  }
  public static newUniqueId(prefix: string | undefined = undefined) {
    return uniqueId(prefix);
  }
}
